/*
 * personeelvast_toolbox.ts
 * Gegenereerd met Junie (AI), 25-5-2026 - Jelmer Jellema - Spin in het Web B.V.
 * Model voor de personeelvast_toolbox-tabel: koppeling tussen een personeelslid en een toolbox (goedkeuring).
 */

import {Basemodel, ModelField, OwnerField} from './basemodel';

export class PersoneelvastToolbox extends Basemodel {
  static override table = 'personeelvast_toolbox';

  @ModelField() override id: number = null;
  /** Id van het personeelslid dat de toolbox moet goedkeuren */
  @ModelField() personeelvast_id: number;
  @OwnerField() toolbox_id: number;
  @ModelField() geaccepteerd: boolean = false;
  @ModelField() createdAt: string = null;
  @ModelField() updatedAt: string = null;
}
